var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "firma-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        attrs: { headerTitle: _vm.texts.title },
      }),
      _c("p", { staticClass: "explanation" }, [
        _vm._v(_vm._s(_vm.texts.explanation)),
      ]),
      !_vm.isDMSUser
        ? _c("InfoBarComponent", { attrs: { infoText: _vm.texts.infoText } })
        : _vm._e(),
      _c("span", { staticClass: "required-fields-advice-base" }, [
        _vm._v(_vm._s(_vm.$t("components.form_generator.required_fields"))),
      ]),
      !_vm.isDMSUser
        ? _c("ReceiverFieldSelectComponent", {
            on: { "emit-receiver": _vm.setReceiver },
          })
        : _vm._e(),
      _vm.isDMSUser
        ? _c("ValidationObserver", {
            ref: "emailInput",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ validate }) {
                    return [
                      _c("LexonTextFieldComponent", {
                        attrs: {
                          label: "Email",
                          id: "email",
                          name: "email",
                          type: "text",
                          validationRules: "required|email",
                        },
                        on: { input: _vm.validateField },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              4252585840
            ),
          })
        : _vm._e(),
      _c("LexonSwitchComponent", {
        class: ["switch-field", { "error-type": _vm.showErrorBar }],
        attrs: {
          id: "switch",
          label: _vm.texts.firmaSwitchLabel,
          name: "switch",
          "hide-details": "",
        },
        model: {
          value: _vm.firmaSwitch,
          callback: function ($$v) {
            _vm.firmaSwitch = $$v
          },
          expression: "firmaSwitch",
        },
      }),
      _c("CustomDialogActionButtonsComponent", {
        attrs: {
          disabledButtons: _vm.disabledActionButton,
          mainAction: _vm.signFirma,
          primaryButtonText: _vm.texts.primaryButtonText,
        },
      }),
      _vm.loadingSpinner
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer",
            attrs: { loadingText: _vm.spinnerText.sending },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }